import 'vendor/jquery/jquery.woimoremenu.js';

const MoreNav = {
  $menuContainer: null,
  menuParentContainer: null,
  init_new($menuContainer, menuParentContainer){
    this.$menuContainer = $menuContainer;
    this.menuParentContainer = menuParentContainer;
    this.updateNav();
  },

  updateNav(){
    this.$menuContainer.woiMoreMenu({
      parentElement: this.menuParentContainer,
      sharedElement: '',
      moreButtonText: 'More <span class="caret-close"></span>',
      moreAction: 'hover',
    });
    $('.hideshow .dropdown-menu ul').remove();
  }
};

export default MoreNav;
